import { render, staticRenderFns } from "./SystemDisplay.vue?vue&type=template&id=70251cf8&lang=pug&"
import script from "./SystemDisplay.vue?vue&type=script&lang=ts&"
export * from "./SystemDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./SystemDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports